import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Modal,
  FormGroup,
  Label,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
} from "reactstrap";

import Select from "react-select";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// actions
import {
  resetUser,
  resetUsers,
  resetError,
  getUsers,
  activateUser,
  editUser,
} from "../../store/users/actions";

import { useDispatch, useSelector } from "react-redux";

import SwitchEvent from "../../components/Skills/ChatEvent/SwitchEvent";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

import ProfilePicture from "../../components/Common/ProfilePicture";
import BadgesEllipsis from "../../components/Common/BadgesEllipsis";
import BadgesEllipsisSoft from "../../components/Common/BadgesEllipsisSoft";

import FilterSelect from "../../components/Common/FilterSelect";

import { getUsersForm } from "../../store/users/actions";
import {
  getOptions,
  renderPagination,
  renderQtdPerPage,
  setClassName,
} from "../../Libs/CrudUtils/crudUtils";
import { isArray } from "../../Libs/CustomMethods/customMethods";

import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

import { schemaAction } from "./UserValidation";

const Users = ({ t }) => {
  const nameCompany = useSelector((state) =>
    state.Login.data && state.Login.data.company
      ? state.Login.data.company.name
      : "Company Name"
  );
  const dispatch = useDispatch();
  const [qtdDefault, setQtdDefault] = useState(7);

  const { register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schemaAction),
  });

  const {
    dataUser,
    dataUserActivate,
    loadingUser,
    loadingUserEditCreate,
    loadingUserActivate,
    errorUser,
    successUser,
    userFormData,
    loadingUserFormData,
  } = useSelector((state) => state.User);

  const [page, setPage] = useState(1);
  const [actionField, setActionField] = useState(null);
  const [dropdown, setDropdown] = useState(false);
  const [dropdownFilter, setDropdownFilter] = useState(false);
  const [dropdownCheckbox, setDropdownCheckbox] = useState({});
  const [modalDelete, setModalDelete] = useState(false);
  const [modalAction, setModalAction] = useState(false);
  const [loadingAction, setLoadingAction] = useState(false);
  const [userId, setUserId] = useState();
  const [userName, setUserName] = useState();

  const [nameFilter, setNameFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const [userCheckedArray, setUserCheckedArray] = useState({
    list: [],
    all: false,
  });
  const [objAction, setObjAction] = useState({});

  const [notFound, setNotFound] = useState(false);

  const [active, setActive] = useState();
  const [status, setStatus] = useState();

  const [filter, setFilter] = useState({});
  const [dataSkills, setDataSkills] = useState([]);
  const [dataGroups, setDataGroups] = useState([]);
  const [dataStatus, setDataStatus] = useState([]);
  const [dataProfiles, setDataProfiles] = useState([]);

  const updateObjAction = (target, value) => {
    setValue(target, value, {
      shouldValidate: value,
    });

    setObjAction((prev) => ({
      ...prev,
      [target]: value,
    }));
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => successUser && dispatch(resetUsers()) && handleFilter(),
  };

  const handleFilter = (inputValue) => {
    filter.extra = [];
    filter.name = "";
    userFormData?.data?.form?.filter_columns?.map((e) => {
      if (e.type === "extra" && dropdownCheckbox[e.name] === true) {
        filter.extra.push(e.name);
      }
    });
    filter.externalId = dropdownCheckbox.external_id ? inputValue : null;

    if (dropdownCheckbox.email === true && dropdownCheckbox.name === true) {
      setNameFilter(inputValue);
      setEmailFilter(inputValue);
      dispatch(getUsers(1, qtdDefault, inputValue, inputValue, filter.externalId, filter));
    } else if (dropdownCheckbox.name === true) {
      setNameFilter(inputValue);
      dispatch(getUsers(1, qtdDefault, inputValue, null, filter.externalId, filter));
    } else if (dropdownCheckbox.email === true) {
      setEmailFilter(inputValue);
      dispatch(getUsers(1, qtdDefault, null, inputValue, filter.externalId, filter));
    } else {
      filter.name = inputValue;
      dispatch(getUsers(1, qtdDefault, null, null, filter.externalId, filter));
    }
    setPage(1);
};



  const handleAction = async (objAction) => {
    const {
      field,
      max_chats,
      commonsremoved: skillsToRemove = [],
      addedskills: skillsToAdd = [],
      externalaccess,
    } = objAction;
    let newFields = {};

    if (field === "maxchat") {
      newFields.max_chats = max_chats;
    }
    if (field === "limitexternalaccess") {
      newFields.external_access = externalaccess;
    }
    let users = userCheckedArray.list.filter((e) => e);
    // TODO: Improve this method this loop will most likely go to the back-end
    users.forEach((e, i) => {
      setTimeout(() => {
        if (i === 0) {
          setLoadingAction(true);
        }
        if (field === "skill") {
          const usrCurrent = e.skills.map((e) => e.id);
          const usrAfterRemoved = usrCurrent.filter(
            (e) => !skillsToRemove.includes(e)
          );
          const toAdd = skillsToAdd.filter((element) =>
            usrAfterRemoved.every((e) => e !== element)
          );
          const skills = [...usrAfterRemoved, ...toAdd];
          newFields.skill_id = skills;
        }
        dispatch(editUser(e.id, newFields));
        if (i === users.length - 1) {
          showToast(
            "success",
            t("Action completed! Click search to update the records!")
          );
          dispatch(resetUsers());
          setLoadingAction(false);
          toggleModalAction();
          setUserCheckedArray((prev) => ({ ...prev, list: [], all: false }));
        }
      }, i * 100);
    });
  };

  const handleActivate = () => {
    dispatch(activateUser(userId, active));
  };

  const updateCommonSkills = (selectedUsers) => {
    let usersSkills = selectedUsers.map((e) => e.skills.map((e) => e.id));
    const commonSkills = usersSkills.reduce((p, c) =>
      p.filter((e) => c.includes(e))
    );
    updateObjAction("addedskills", []);
    updateObjAction("commonsremoved", []);
    updateObjAction("skills", commonSkills);
    updateObjAction("commonskills", commonSkills);
  };

  const toggleDropdownFilter = () => {
    setDropdownFilter((prev) => !prev);
  };

  const toggleDropdown = () => {
    setDropdown((prev) => !prev);
  };

  const toggleModalDelete = () => {
    setModalDelete((prev) => !prev);
  };

  const toggleModalAction = (field) => {
    setValue("field", field, {
      shouldValidate: field,
    });
    if (field === "skill") {
      let selectedUsers = userCheckedArray.list.filter((e) => e);
      updateCommonSkills(selectedUsers);
    }
    setActionField(field);
    setModalAction((prev) => !prev);
  };

  const setUserIdName = (user) => {
    setUserId(user.id);
    setUserName(user.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getUsers(value, qtdDefault, nameFilter, emailFilter, null, filter));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataUser && dataUser.paging) {
      if (page < dataUser.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  const valueSelectMulti = (arrayOfIds) =>
    getOptions(
      userFormData?.data?.form?.departments[0]?.skills,
      loadingUser
    )?.filter((element) => arrayOfIds?.some((e) => e === element.value)) ??
    null;

  const renderMaxChat = () => (
    <Col sm="12">
      <Label>{t("Max Chat")}</Label>
      <input
        ref={() => register({ name: "max_chats" })}
        type="number"
        className={setClassName(errors.max_chats, "form-control")}
        placeholder={t("Enter maximum chats")}
        onChange={(e) => {
          let value = e?.target?.value;
          updateObjAction("max_chats", value);
        }}
        value={objAction?.max_chats ?? ""}
      />
      <div className="invalid-feedback d-block">
        {t(errors.max_chats?.message)}
      </div>
    </Col>
  );
  const renderLimitExternalAccess = () => (
    <Col sm="12">
      <div ref={() => register({ name: "externalaccess" })}>
        <SwitchEvent
          id="externalAccessComponent"
          title="Limit external access"
          tooltip="This button enables the functionality to limit external access at user login"
          value={objAction?.externalaccess ?? false}
          onChange={(val) => {
            updateObjAction("externalaccess", val);
          }}
        />
      </div>
      <div className="invalid-feedback d-block">
        {t(errors.max_chats?.message)}
      </div>
    </Col>
  );

  const renderSkill = () => {
    return (
      <Col sm="12">
        <div ref={() => register({ name: "commonskills" })}></div>
        <div ref={() => register({ name: "addedskills" })}>
          <Label>{t("Added skills")}</Label>
          <div className="border rounded pt-2 px-2 mb-2">
            {objAction?.addedskills?.length > 0 ? (
              valueSelectMulti(objAction?.addedskills).map((item, key) => (
                <Badge
                  key={key}
                  className="font-size-12 mr-2 mb-2"
                  color="success"
                >
                  {item.label}
                </Badge>
              ))
            ) : (
              <div className="mb-2">{t("No skills added")}</div>
            )}
          </div>
        </div>
        <div ref={() => register({ name: "commonsremoved" })}>
          <Label>{t("Removed skills")}</Label>
          <div className="border rounded pt-2 px-2 mb-2">
            {objAction?.commonsremoved?.length > 0 ? (
              valueSelectMulti(objAction?.commonsremoved).map((item, key) => (
                <Badge
                  key={key}
                  className="font-size-12 mr-2 mb-2"
                  color="danger"
                >
                  {item.label}
                </Badge>
              ))
            ) : (
              <div className="mb-2">{t("No skills removed")}</div>
            )}
          </div>
        </div>
        <FormGroup className="select2-container">
          <Label>{t("Skills")}</Label>
          <Select
            ref={() => register({ name: "skills" })}
            classNamePrefix="select2-selection"
            className={setClassName(errors.skills, " select2-selection")}
            placeholder={t("Select") + "..."}
            options={getOptions(
              userFormData?.data?.form?.departments[0]?.skills,
              loadingUser
            )}
            onChange={(e) => {
              let value = e ? e?.map((e) => e.value) : [];
              if (objAction?.commonskills?.length > 0) {
                const commonsRemoved = objAction?.commonskills.filter(
                  (x) => !value.includes(x)
                );
                updateObjAction("commonsremoved", commonsRemoved);
                const addSkills = value.filter(
                  (x) => !objAction?.commonskills.includes(x)
                );
                updateObjAction("addedskills", addSkills);
              } else {
                const addSkills = value.filter(
                  (x) => !objAction?.commonskills.includes(x)
                );
                updateObjAction("addedskills", addSkills);
              }

              updateObjAction("skills", value);
            }}
            value={valueSelectMulti(objAction?.skills)}
            isMulti
          />
          <div className="invalid-feedback d-block">
            {t(errors?.skills?.message)}
          </div>
        </FormGroup>
      </Col>
    );
  };

  const switchRenderField = (field) => {
    switch (field) {
      case "maxchat":
        return renderMaxChat();
      case "skill":
        return renderSkill();
      case "limitexternalaccess":
        return renderLimitExternalAccess();
      default:
        break;
    }
  };

  useEffect(() => {
    userFormData?.data?.form?.filter_columns?.map((e) => {
      setDropdownCheckbox((prev) => ({
        ...prev,
        [e.name]: true,
      }));
    });
    if (userFormData?.data?.form?.departments[0]?.skills) {
      let firstOpt = [{ id: 0, name: t("All skills"), isFixed: true }];
      let restOpt = userFormData.data.form.departments[0].skills;
      setDataSkills(firstOpt.concat(restOpt));
    }

    if (userFormData?.data?.form?.departments[0]?.groups) {
      let firstOpt = [{ id: 0, name: t("All groups"), isFixed: true }];
      let restOpt = userFormData.data.form.departments[0].groups;
      setDataGroups(firstOpt.concat(restOpt));
    }

    if (userFormData?.data?.form?.departments[0]?.profiles) {
      let firstOpt = [{ id: 0, name: t("All profiles"), isFixed: true }];
      let restOpt = userFormData.data.form.departments[0].profiles;
      setDataProfiles(firstOpt.concat(restOpt));
    }

    setDataStatus([
      {
        id: undefined,
        name: t("All status"),
      },
      {
        id: true,
        name: t("Actives"),
      },
      {
        id: false,
        name: t("Inactives"),
      },
    ]);
  }, [userFormData, t]);

  useEffect(() => {
    dispatch(getUsersForm());
  }, [dispatch]);

  useEffect(() => {
    dispatch(resetUser());
    if (dataUserActivate && dataUserActivate.message) {
      showToast("success", t(dataUserActivate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successUser]);

  useEffect(() => {
    if (errorUser && typeof errorUser === "object") {
      errorUser.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorUser) {
        showToast("error", t(errorUser));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorUser]);

  useEffect(() => {
    if (dataUser !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataUser]);

  useEffect(() => {
    if (dataUser !== null) {
      setNotFound(false);
      if (isArray(dataUser.queryset)) {
        let aux = Array(dataUser.queryset.length).fill(false);
        setUserCheckedArray((prev) => ({ ...prev, list: aux, all: false }));
      }
    } else {
      setNotFound(true);
    }
  }, [dataUser]);

  useEffect(() => {
    handleFilter();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/users"
            title={t("Dashboard")}
            breadcrumbItem={t("Users")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody className="card-height">
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name);
                    }}
                  >
                    <Row className="mb-2">
                      <Col xs="12" md="3" xl="2" className="mb-3">
                        <div className="mr-3">
                          <h5 className="font-size-16">
                            <i className="bx bx-store mr-2"></i>
                            {nameCompany}
                          </h5>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Row className="mb-3 ml-4 mr-4 mt-009">
                        {userFormData?.data?.form?.filter_columns ? (
                          <ButtonDropdown
                            className="form-group mt-4"
                            isOpen={dropdownFilter}
                            toggle={toggleDropdownFilter}
                          >
                            <DropdownToggle
                              caret
                              className="bx bx-filter-alt search-icon icon-button"
                              color="primary"
                            ></DropdownToggle>
                            <DropdownMenu top="true">
                              {userFormData?.data?.form?.filter_columns?.map(
                                (e, idx) => (
                                  <DropdownItem
                                    key={`${e.name}`}
                                    toggle={false}
                                    onClick={() => {
                                      //let booleanValue = !(dropdownCheckbox[e.name]);
                                      setDropdownCheckbox((prev) => ({
                                        ...prev,
                                        [e.name]: !dropdownCheckbox[e.name],
                                      }));
                                    }}
                                  >
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input pointer"
                                        id="customControlInline"
                                        disabled={true}
                                        checked={dropdownCheckbox[e.name]}
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor="customControlInline"
                                      >
                                        {t(e?.title)}
                                      </label>
                                    </div>
                                  </DropdownItem>
                                )
                              )}
                            </DropdownMenu>
                          </ButtonDropdown>
                        ) : (
                          <ButtonDropdown
                            className="form-group mt-4"
                            isOpen={dropdownFilter}
                            toggle={toggleDropdownFilter}
                          ></ButtonDropdown>
                        )}

                        <FormGroup>
                          <AvField
                            label={t("Filter")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t(
                              "Enter the text to filter the users"
                            )}
                            onClick={toggleDropdownFilter}
                            onChange={(e) => setNameFilter(e.target.value)}
                          />
                        </FormGroup>
                      </Row>

                      <Col xs="12" md="3" lg="3" className="mb-3">
                        <FilterSelect
                          name="skills"
                          filterItemTitle={t("Skill")}
                          isLoadingData={loadingUserFormData}
                          data={dataSkills}
                          onChange={(target, e) =>
                            setFilter({
                              ...filter,
                              [target]: e.map((skill) => skill.value),
                            })
                          }
                          isMulti
                        />
                      </Col>
                      <Col xs="12" md="3" lg="3" className="mb-3 col-xl-auto">
                        <FilterSelect
                          name="groups"
                          filterItemTitle={t("Group")}
                          isLoadingData={loadingUserFormData}
                          data={dataGroups}
                          onChange={(target, e) =>
                            setFilter({
                              ...filter,
                              [target]: e.map((group) => group.value),
                            })
                          }
                          isMulti
                        />
                      </Col>
                      <Col xs="12" md="3" lg="3" className="mb-3 col-xl-auto">
                        <FilterSelect
                          name="profiles"
                          filterItemTitle={t("Profile")}
                          isLoadingData={loadingUserFormData}
                          data={dataProfiles}
                          onChange={(target, e) =>
                            setFilter({
                              ...filter,
                              [target]: e.map((profile) => profile.value),
                            })
                          }
                          isMulti
                        />
                      </Col>
                      <Col xs="12" md="3" lg="3" xl="2" className="mb-3 ">
                        <FilterSelect
                          name="status"
                          filterItemTitle={t("Status")}
                          isLoadingData={loadingUserFormData}
                          data={dataStatus}
                          onChange={(target, e) => {
                            setFilter({
                              ...filter,
                              [target]: e.value,
                            });
                          }}
                        />
                      </Col>
                      <Col
                        md="auto"
                        lg="auto"
                        className="mt-auto filter-create-btn"
                        style={{
                          marginBottom: "2.05rem",
                        }}
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                          disabled={loadingUser || loadingUserEditCreate}
                        >
                          {loadingUserEditCreate ? (
                            <Spinner size="sm" animation="border" />
                          ) : (
                            <div className="d-flex justify-content-center">
                              <i className="mdi mdi-feature-search-outline mr-2" />
                              <div>{t("Search")}</div>
                            </div>
                          )}
                        </Button>
                      </Col>
                    </Row>
                    <Row className="mb-3 justify-content-end">
                      <Col xs="12" md="12" lg="auto">
                        <ButtonDropdown
                          className={
                            !userCheckedArray.list.filter((e) => e).length
                              ? "isDisabled"
                              : ""
                          }
                          isOpen={dropdown}
                          toggle={toggleDropdown}
                          disabled={
                            !userCheckedArray.list.filter((e) => e).length
                          }
                        >
                          <DropdownToggle
                            caret
                            className="btn waves-effect waves-light w-100"
                            color="primary"
                          >
                            {t("Action")}
                          </DropdownToggle>
                          <DropdownMenu right>
                            <DropdownItem
                              onClick={() => toggleModalAction("maxchat")}
                            >
                              {t("Max. Chat")}
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => toggleModalAction("skill")}
                            >
                              {t("Skills")}
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                toggleModalAction("limitexternalaccess")
                              }
                            >
                              {t("Limit external access")}
                            </DropdownItem>
                          </DropdownMenu>
                        </ButtonDropdown>
                      </Col>
                      <Col
                        xs="12"
                        md="12"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-user">
                          <Link to={`/user`}>
                            <Button
                              type="button"
                              color="success"
                              className="waves-effect waves-light w-100 mr-2 "
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add User")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>
                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th className="text-center">
                              <div className="custom-control custom-checkbox">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  checked={userCheckedArray.all}
                                  onChange={() => { }}
                                />
                                <label
                                  className="custom-control-label pointer"
                                  onClick={() => {
                                    if (dataUser) {
                                      let list = Array(
                                        userCheckedArray.list.length
                                      ).fill(false);
                                      if (!userCheckedArray.all) {
                                        list = dataUser.queryset.map(
                                          (user) => ({
                                            id: user.id,
                                            name: user.name,
                                            skills: user.skills,
                                          })
                                        );
                                      }
                                      setUserCheckedArray((prev) => ({
                                        ...prev,
                                        all: !prev.all,
                                        list,
                                      }));
                                    }
                                  }}
                                ></label>
                              </div>
                            </th>
                            <th>{"#"}</th>
                            <th>{t("Name")}</th>
                            <th>{t("Email")}</th>
                            <th>{t("Profile")}</th>
                            <th>{t("Skills")}</th>
                            <th>{t("Group")}</th>
                            <th>{t("Max. Chat")}</th>
                            <th>{t("Status")}</th>
                            <th>{t("Edit")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingUser ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="10" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataUser &&
                            dataUser.queryset &&
                            dataUser.queryset.length > 0 ? (
                            dataUser.queryset.map((user, key) => (
                              <tr key={key}>
                                <td className="text-center p-0">
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      checked={
                                        userCheckedArray?.list?.[key] ?? false
                                      }
                                      onChange={() => { }}
                                    />
                                    <label
                                      className="custom-control-label pointer"
                                      onClick={() => {
                                        let aux = userCheckedArray.list;
                                        let all = userCheckedArray.all;
                                        if (userCheckedArray.list[key]) {
                                          aux[key] = false;
                                          all = false;
                                        } else {
                                          aux[key] = {
                                            id: user.id,
                                            name: user.name,
                                            skills: user.skills,
                                          };
                                        }
                                        setUserCheckedArray((prev) => ({
                                          ...prev,
                                          all,
                                          list: aux,
                                        }));
                                      }}
                                    ></label>
                                  </div>
                                </td>
                                <td>
                                  <ProfilePicture
                                    name={user.name}
                                    src={user.url_avatar}
                                  />
                                </td>
                                <td className="column-text-overflow-10">
                                  {user.name}
                                </td>
                                <td>
                                  <Link
                                    to="#"
                                    className="text-body font-weight-bold"
                                  >
                                    {user.email}
                                  </Link>
                                </td>
                                <td>
                                  {user.profiles.map((profile) => profile.name)}
                                </td>
                                <td>
                                  <BadgesEllipsisSoft objItems={user.skills} />
                                </td>
                                <td>
                                  {<BadgesEllipsis objItems={user.groups} />}
                                </td>
                                <td>{user.max_chats}</td>
                                <td>
                                  <div
                                    className="custom-control custom-switch"
                                    dir="ltr"
                                  >
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id={"customSwitch" + user.id}
                                      readOnly
                                      checked={user.active}
                                      onClick={() => {
                                        setUserIdName(user);
                                        toggleModalDelete();
                                        setStatus(
                                          user.active
                                            ? t("deactivate")
                                            : t("activate")
                                        );
                                        setActive({ active: !user.active });
                                      }}
                                    />
                                    <label
                                      className="custom-control-label pointer"
                                      htmlFor={"customSwitch" + user.id}
                                    >
                                      {user.active
                                        ? t("Active")
                                        : t("Inactive")}
                                    </label>
                                  </div>
                                </td>
                                <td>
                                  <Link
                                    to={`/user/${user.id}`}
                                    className="text-primary text-center"
                                    id="edit"
                                  >
                                    <i
                                      className="mdi mdi-pencil font-size-18 px-2"
                                      id={`edittooltip${key}`}
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="auto"
                                      target={`edittooltip${key}`}
                                    >
                                      {t("Edit")}
                                    </UncontrolledTooltip>
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </PerfectScrollbar>
                  </div>
                  <div className="d-flex justify-content-between pt-2">
                    {renderQtdPerPage(qtdDefault, setQtdDefault, t)}
                    <div>
                      <Label>
                        {`${t("Total number of users : ")}${dataUser?.total || 0
                          }`}
                      </Label>
                    </div>
                    {renderPagination(
                      page,
                      dataUser?.paging,
                      handlePreviousPage,
                      handlePage,
                      handleNextPage
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal isOpen={modalDelete || loadingUserActivate}>
        <div className="modal-body font-size-18 text-center">
          {`${t("Do you want to")} ${status}`}
          <strong> {userName}</strong>?
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={toggleModalDelete}
            className="btn btn-danger waves-effect"
            data-dismiss="modal"
            style={{ backgroundColor: "#f14646" }}
          >
            {t("No")}
          </button>
          {loadingUserActivate ? (
            <button
              type="button"
              className="btn btn-secondary waves-effect waves-light"
              disabled
            >
              <Spinner size="sm" animation="border" />
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-secondary waves-effect waves-light"
              onClick={() => {
                toggleModalDelete();
                if (userId) handleActivate();
              }}
            >
              {t("Yes")}
            </button>
          )}
        </div>
      </Modal>
      <Modal isOpen={modalAction} ref={() => register({ name: "field" })}>
        <form onSubmit={handleSubmit(handleAction)}>
          <ModalHeader
            toggle={() => toggleModalAction(null)}
            className="px-4 pt-4"
          >
            <span className="text-left">{t("Action")}</span>
          </ModalHeader>
          <ModalBody className="px-4">
            <Row>
              <Col>
                <div className="d-flex justify-content-between">
                  <Label className="control-label font-weight-bold">
                    {t("Selected users") + ":"}
                  </Label>
                  <Label className="control-label font-weight-bold">
                    {t("Total") +
                      ": " +
                      userCheckedArray.list.filter((e) => e).length}
                  </Label>
                </div>
                <PerfectScrollbar
                  className="border rounded pt-2 px-2 mb-2"
                  style={{ height: 150, overflow: "auto" }}
                >
                  <table className="w-100">
                    <tbody>
                      {userCheckedArray.list.map(
                        (user, key) =>
                          user && (
                            <tr key={key}>
                              <td className="column-text-overflow-10">
                                {user.name}
                              </td>
                            </tr>
                          )
                      )}
                    </tbody>
                  </table>
                </PerfectScrollbar>
              </Col>
            </Row>
            <Row>{switchRenderField(actionField)}</Row>
          </ModalBody>
          <ModalFooter className="px-4 pb-4">
            <button
              type="button"
              onClick={() => toggleModalAction(null)}
              className="btn waves-effect waves-light btn-dark"
              data-dismiss="modal"
            >
              {t("Cancel")}
            </button>

            {loadingAction ? (
              <button
                type="button"
                color="primary"
                className="btn btn-primary waves-effect waves-light"
              >
                <Spinner size="sm" animation="border" />
              </button>
            ) : (
              <button
                type="submit"
                color="primary"
                className="btn btn-primary waves-effect waves-light"
                disabled={
                  actionField === "skill" &&
                  !objAction?.addedskills?.length &&
                  !objAction?.commonsremoved?.length
                }
              >
                {t("Confirm")}
              </button>
            )}
          </ModalFooter>
        </form>
      </Modal>
    </React.Fragment>
  );
};

export default withTranslation()(Users);
